module.exports = __webpack_public_path__ + "img/MetsoMinerals.705f9b29.jpg";